<div class="row" [formGroup]="shipperdetailsForm">
  <div class="text-end icon-mat-close">
    <i mat-dialog-close class="bi bi-x"></i>
  </div>
  <div class="secondary-details  mb-2">
    <span>{{ 'configuration.motherShipperDetails.motherShipperDetails' | translate }}</span>
    <div class="col-12 text-end" >
      <mat-checkbox *ngIf="isLbx"
        (change)="setDefault($event.checked)"
        formControlName="isDefault"
        class="text-wrap mr-3"
        id="checkbox"
        >{{ 'configuration.motherShipperDetails.setAsDefault' | translate }}
      </mat-checkbox>
      <mat-slide-toggle class="ml-2"
        formControlName="isBabyLineManifest"
        [checked]="isBabyLineManifest"
        >{{ 'configuration.motherShipperDetails.setBabyLineItemManifest' | translate }}</mat-slide-toggle
      >
    </div>
  </div>
  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.nickName' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperNickName"
      class="form-control"
      type="text" />
    <app-error-component [controlName]="shipperdetailsForm.get('shipperNickName')">
    </app-error-component>
  </div>

  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.companyName' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperCompanyName"
      class="form-control"
      type="text" />
    <app-error-component [controlName]="shipperdetailsForm.get('shipperCompanyName')">
    </app-error-component>
  </div>

  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.contactPersonName' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperContactPersonName"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperContactPersonName')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.addressLine1' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperAddressLine1"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperAddressLine1')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.addressLine2' | translate }}: </label>
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperAddressLine2"
      class="form-control"
      type="text" />
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.addressLine3' | translate }}: </label>
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperAddressLine3"
      class="form-control"
      type="text" />
  </div>
  <div class="col-3 form-group address">
    <label>{{ 'configuration.motherShipperDetails.countryName' | translate }}: </label>
    <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
      <input
        matInput
        (keyup)="motherShipperBtn = false"
        type="text"
        formControlName="shipperCountryName"
        [matAutocomplete]="auto" />

      <mat-autocomplete
        (optionSelected)="selectionChanged($event?.option.value)"
        #auto="matAutocomplete">
        <mat-option *ngFor="let item of list" [value]="item?.name">
          {{ item?.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="col-3 form-group address">
    <label
      [ngClass]="{
        'required-field': isPostalCodeReq === true
      }"
      >{{ 'configuration.motherShipperDetails.postalCode' | translate }}</label
    ><label>:</label>
    <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
      <input
        matInput
        (keyup)="motherShipperBtn = false"
        type="text"
        formControlName="shipperPostalCode"
        [matAutocomplete]="autoPostalCode" />

      <mat-autocomplete #autoPostalCode="matAutocomplete">
        <mat-option
          *ngFor="let item of cityList"
          (onSelectionChange)="selectionPincodeChanged($event, item)"
          [value]="item?.postalCode">
          {{ item?.postalCode }} <span *ngIf="item?.city">,</span> {{ item?.city }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperPostalCode')"></app-error-component>
    <span class="msg" *ngIf="!isPostalCodeValid">{{ 'configuration.motherShipperDetails.invalidPostalCode' | translate }}</span>
  </div>

  <div class="col-3 form-group address">
    <label class="required-field">{{ 'configuration.motherShipperDetails.cityName' | translate }}</label>:
    <mat-form-field class="w-100" style="font-size: 14px" appearance="outline">
      <input
        (keyup)="motherShipperBtn = false"
        matInput
        type="text"
        formControlName="shipperCityName"
        [matAutocomplete]="autoCity" />

      <mat-autocomplete #autoCity="matAutocomplete">
        <mat-option
          *ngFor="let item of cityList"
          (onSelectionChange)="selectionCityChanged($event, item)"
          [value]="item?.city">
          {{ item?.city }}<span *ngIf="item?.postalCode">,</span> {{ item?.postalCode }}
          <span *ngIf="item?.cityDistrict">,</span> {{ item?.cityDistrict }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperCityName')"></app-error-component>
    <span class="msg" *ngIf="!isCityValid">{{ 'configuration.motherShipperDetails.invalidCityName' | translate }}</span>
  </div>

  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.countryCode' | translate }}</label>:
    <input readonly formControlName="shipperCountryCode" class="form-control" type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperCountryCode')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.suburb' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shippersuburb"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shippersuburb')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.provinceCode' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperProvinceCode"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperProvinceCode')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label class="required-field">{{ 'configuration.motherShipperDetails.phone' | translate }}</label>:
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperPhone"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperPhone')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.email' | translate }}: </label>
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperEmail"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperEmail')"></app-error-component>
  </div>

  <div class="col-3 form-group">
    <label>{{ 'configuration.motherShipperDetails.mobilePhone' | translate }}: </label>
    <input
      (keyup)="motherShipperBtn = false"
      formControlName="shipperMobilePhone"
      class="form-control"
      type="text" />
    <app-error-component
      [controlName]="shipperdetailsForm.get('shipperMobilePhone')"></app-error-component>
  </div>

  <div class="col-12 text-end">
    <button
      [disabled]="
        this.shipperdetailsForm.pristine ||
        !this.shipperdetailsForm.valid ||
        motherShipperBtn ||
        !isPostalCodeCityValid()
      "
      class="primary-btn m-2"
      (click)="saveShipperConfig()">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
